import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IGeographicalZonesApiClient } from './i-geographical-zones-api.client';
import {
  ICreateGeographicalZoneRequest,
  IGeographicalZoneResponse,
  IUpdateGeographicalZoneReqeust,
} from '../dtos';
import { geographicalZonesData } from '../data/geographical-zones.data';
import { ICreateGeographicalZoneResponse } from '../dtos/responses/create-geographical-zone.response';
import { IPaginationParameters, IPaginationResponse } from '../../../data-access';


@Injectable({
  providedIn: 'root'
})
export class GeographicalZonesInMemoryApiClient implements IGeographicalZonesApiClient {
  constructor(protected http: HttpClient) {}

  get(
        paginationParameters?: IPaginationParameters
  ): Observable<IPaginationResponse<IGeographicalZoneResponse>> {
    return of(geographicalZonesData.geographicalZonesResponse);
  }

  getById(id: string): Observable<IGeographicalZoneResponse> {
    return of(geographicalZonesData.geographicalZoneResponse);
  }

  create(request: ICreateGeographicalZoneRequest): Observable<ICreateGeographicalZoneResponse> {
    return of(geographicalZonesData.createGeographicalZoneResponse);
  }

  update(id: string, request: IUpdateGeographicalZoneReqeust): Observable<void> {
    return of();
  }
}
